// NOTE:: THIS IS A SERVERMIDDLEWARE NOT A CLIENT MIDDLEWARE
// https://nuxtjs.org/docs/configuration-glossary/configuration-servermiddleware/
export default function (req, res, next) {
  const { url = '' } = req

  const oldRouterBase = '/v2/'
  const newRouterBase = '/'

  // Remove firstname/firstName and lastname/lastName parameters if present
  try {
    if (url && (url.includes('firstname=') || url.includes('firstName=') || url.includes('lastname=') || url.includes('lastName='))) {
      const urlObj = new URL(url, 'https://dummy.com')
      urlObj.searchParams.delete('firstname')
      urlObj.searchParams.delete('firstName')
      urlObj.searchParams.delete('lastname')
      urlObj.searchParams.delete('lastName')
      const location = urlObj.pathname + urlObj.search

      res.writeHead(301, {
        location
      })

      res.end()
      return
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error parsing URL:', error)
  }

  if (url && url.startsWith(oldRouterBase)) {
    const location = url.replace(oldRouterBase, newRouterBase)

    res.writeHead(301, {
      location
    })

    res.end()

    return
  }

  if (url && !!url.match(/^\/\w\w-uk\//g)) {
    const langParam = url.match(/^\/\w\w-uk\//g)[0]
    const newLangParam = langParam.replace('-uk', '-gb')
    const location = url.replace(langParam, newLangParam)

    res.writeHead(301, {
      location
    })

    res.end()

    return
  }

  const indexHTMLRegex = /\/index\.html$/

  if (url && url.match(indexHTMLRegex)) {
    const location = url.replace(indexHTMLRegex, '/')

    res.writeHead(301, {
      location
    })

    res.end()

    return
  }

  if (url && url.includes('/faq')) {
    const location = '/customer-service'

    res.writeHead(301, {
      location
    })

    res.end()

    return
  }

  if (url && url.includes('/vacatures')) {
    const location = 'https://jobs.onthatass.com/'

    res.writeHead(301, {
      location
    })

    res.end()

    return
  }

  next()
}
